import { useContext } from "react"
import { CategoriesNavigateContext } from "../contexts/categoriesNavigateContext"

export const useCategoriesNavigate = () => {
  const context = useContext(CategoriesNavigateContext)

  return context
}
